import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  experiment: {
    read: ["all"],
    create: ["master", "administrator", "program_manager", "staff", "client"],
    update: ["master", "administrator", "program_manager", "staff", "client"],
    delete: ["master", "administrator", "program_manager", "staff", "client"],
    config: ["master", "program_manager"]
  }
};
